import { SearchOutlined, CloseOutlined } from '@ant-design/icons';
import Input from '../../UI/inputs/Input';
import React from 'react';
import styled from "styled-components";

const InputWrapper = styled.div`
  position: relative;
  width: 100%;
  margin: 1rem 0;
  flex: 1;
  
  & .padded-left {
    padding-left: 2.5rem;
  }
`;

const IconSearch = styled.span`
  position: absolute;
  font-size: 1.2rem;
  top: 40%;
  left: 0.5rem;
  cursor: pointer;
  transform: translateY(-50%);
  color: #627d95;
`;

const IconClose = styled.span`
  position: absolute;
  font-size: 1.2rem;
  top: 40%;
  right: 0.5rem;
  cursor: pointer;
  transform: translateY(-50%);
  color: #627d95;
`;

const EmbedSearchInput = (props: any) => {
    const [searchTerm, setSearchTerm] = React.useState('');

    const handleChange = (value: string) => {
        setSearchTerm(value);
        props.onSearch(value);
    };

    const clearState = () => {
        setSearchTerm('');
        props.onSearch('');
    }

    return (
        <InputWrapper className="padded-left">
            <Input
                value={searchTerm}
                onChange={(e: any) => handleChange(e.target.value)}
                onPressEnter={() => props.onSearch(searchTerm)}
                className="search-input"
                size="large"
                placeholder="Search..."
            />
            <IconSearch onClick={() => props.onSearch(searchTerm)}>
                <SearchOutlined />
            </IconSearch>
            {searchTerm && (
                <IconClose onClick={clearState}>
                    <CloseOutlined />
                </IconClose>
            )}
        </InputWrapper>
    );
}

export default EmbedSearchInput; 